import React, { PropTypes } from 'react';
import EstimateModal from './EstimateModal';
import InvoiceModal from './InvoiceModal';

const CopyModalsLayout = ({ caseId, isAAST, targetId }) => (
  <div>
    <InvoiceModal
      key="invoice"
      caseId={caseId}
      isAAST={isAAST}
      targetId={targetId}
    />
    {!isAAST && (
      <EstimateModal key="estimate" caseId={caseId} targetId={targetId} />
    )}
  </div>
);

CopyModalsLayout.propTypes = {
  caseId: PropTypes.number.isRequired,
  isAAST: PropTypes.bool.isRequired,
  targetId: PropTypes.number,
};

export default CopyModalsLayout;



// WEBPACK FOOTER //
// ./src/modules/saas/invoices/imports/components/CopyModalsLayout.js